import { Container, HeaderSection } from '../style';
import Logo from '../../../images/logo_white.png';
import LogoCraques from '../../../images/logo_craques_enem.png';
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import RenderModal from '../../../components/renderModal';
import ModalLead from '../../../components/ModalLead';
import { SUBSCRIPTION_KEY } from '../../../core/storageKeys';

const SIMULADO_ROUTE = '/simulado/simuladinho-craques-do-enem2026';

const CraquesEnemLanding = ({ history }) => {
  const [toggleModal, setToggleModal] = useState(false);

  useEffect(() => {
    const isSubscribed = localStorage.getItem(SUBSCRIPTION_KEY);
    if (isSubscribed) {
      history.push(SIMULADO_ROUTE);
    } else {
      setToggleModal(true);
    }
  }, [history]);

  return (
    <Container>
      <HeaderSection>
        <img
          src={Logo}
          alt="Logo da Aprova Total"
          style={{ width: '185px', margin: 'auto' }}
        />
      </HeaderSection>

      <section
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px 16px',
          gap: '32px',
        }}
      >
        <img
          src={LogoCraques}
          alt="Logo Craques do ENEM 2026"
          style={{ width: '320px', maxWidth: '90%' }}
        />

        <div
          style={{
            width: '75%',
            maxWidth: '720px',
            margin: 'auto',
            background: '#1B27AB20',
            padding: '32px 24px',
            borderRadius: '12px',
            border: '2px solid #0E8030',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '24px',
          }}
        >
          <p
            style={{
              color: '#FFFFFF',
              fontWeight: 700,
              fontSize: '28px',
              textAlign: 'center',
              margin: 0,
              lineHeight: 1.2,
            }}
          >
            Faça o simulado e melhore seu desempenho para o ENEM!
          </p>
          <button
            style={{
              background: '#ED7B22',
              color: '#FFFFFF',
              fontWeight: 700,
              fontSize: '16px',
              padding: '12px 28px',
              borderRadius: '12px',
              border: 'none',
              cursor: 'pointer',
              textTransform: 'uppercase',
            }}
            onClick={() => setToggleModal(true)}
          >
            Fazer o Simulado
          </button>
        </div>
      </section>

      {toggleModal && (
        <RenderModal>
          <ModalLead
            toggleModal={() => setToggleModal(false)}
            onSuccess={() => history.push(SIMULADO_ROUTE)}
          />
        </RenderModal>
      )}
    </Container>
  );
};

export default withRouter(CraquesEnemLanding);
